import request from 'sb-request'
import { useCallback, useMemo } from 'sb-hooks'
import { ModalVisibilityProps } from 'sb-modal'
import { useForm } from 'formular'
import { required } from 'helpers/validation'
import actions from 'redux/actions'
import { snowplow } from 'common/helpers'

import messages from './messages'
import changeFrequencyFeedbackQuery from './changeFrequencyFeedback.graphql'


export type ChangeFrequencyFeedbackModalProps = {}

const useChangeFrequencyFeedbackModal = (props: ChangeFrequencyFeedbackModalProps & ModalVisibilityProps) => {
  const { closeModal, onClose } = props

  const form = useForm<ChangeFrequencyFeedbackModal.FormValues>({
    fields: {
      reason: [ required ],
      comments: [],
    },
    initialValues: {
      reason: '',
      comments: '',
    },
  })

  const reasons = useMemo<ChangeFrequencyFeedbackModal.Reason[]>(() => ([
    // TODO replace value with short codes - added on 2020-05-19 by maddoger
    { title: messages.reasonCost, value: messages.reasonCost.en, withComments: false },
    { title: messages.reasonDontNeed, value: messages.reasonDontNeed.en, withComments: false },
    { title: messages.reasonTakesLonger, value: messages.reasonTakesLonger.en, withComments: false },
    { title: messages.reasonOther, value: messages.reasonOther.en, withComments: true },
  ]), [])

  const onSubmit = useCallback(async () => {
    let values: ChangeFrequencyFeedbackModal.FormValues

    try {
      values = await form.submit()
    }
    catch (error) {
      console.error(error)
      return
    }

    const { reason, comments } = values

    snowplow.track('Change frequency reason submit', {
      reason,
    })

    await request.gql('changeFrequencyFeedback', {
      body: {
        query: changeFrequencyFeedbackQuery,
        variables: {
          input: {
            reason,
            comment: comments,
          },
        },
      },
      withNestedErrors: true,
    })

    actions.misc.notifications.show('alert', {
      title: messages.notificationTitle,
    })

    closeModal()
  }, [ closeModal, form ])

  return {
    reasons,
    form,
    onSubmit,
    onClose,
  }
}


export default useChangeFrequencyFeedbackModal
